
import { Observable, Subject } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { PedidoDTO } from 'src/app/model/pedidoDTO';
import { PreviaPedidoDTO } from 'src/app/model/previaPedidoDTO';
import { DetallePedidoDTO } from 'src/app/model/detallePedidoDTO';


const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  @Injectable({
    providedIn: 'root'
  })
  export class PedidoDTOService {
    private url : string = `${environment.HOST}/api/pedidosdto`;


    constructor(
        private http : HttpClient,
        private router : Router
      ) { }

   


      
 // getProductosDTO() {
   // return this.http.get<ProductosDTO>(`${this.url}/productodto`);
  //}


  getDetallePedidoByIndice(idPedido:number,indice:number,idProducto:number):Observable<DetallePedidoDTO[]>{
    return this.http.get<DetallePedidoDTO[]>(`${this.url}/detalle-pedido-by-indice/${idPedido}/${indice}/${idProducto}`);
  }



  getPedidoById(idPedido:number):Observable<PedidoDTO[]>{
    return this.http.get<PedidoDTO[]>(`${this.url}/pedido-by-id/${idPedido}`);
  }



  getDetallePedidoById(idPedido:number,idEstado:number):Observable<DetallePedidoDTO[]>{
    return this.http.get<DetallePedidoDTO[]>(`${this.url}/detalle-pedido-by-id/${idPedido}/${idEstado}`);
  }

getPedidoByNuevos(idEstado:number):Observable<PreviaPedidoDTO[]>{
  return this.http.get<PreviaPedidoDTO[]>(`${this.url}/previa-pedido/${idEstado}`);
}

getPedidoByFinalizados(idEstado:number):Observable<PedidoDTO[]>{
    return this.http.get<PedidoDTO[]>(`${this.url}/by-estado/${idEstado}`);
  }

  getPedidoByAnulados(idEstado:number):Observable<PedidoDTO[]>{
    return this.http.get<PedidoDTO[]>(`${this.url}/by-estado/${idEstado}`);
  }


 

    }